export default "__VITE_ASSET__Dtc9W2Su__"